<template>
  <div class="filter">
    <v-select
      v-if="getLectors"
      :searchable="true"
      v-model="secondName"
      class="selectaria__select selectaria__select_long"
      :options="lectors"
      label="label"
      :reduce="(lectors) => lectors.value"
      :closeOnSelect="true"
      :placeholder="$t('fields_labels.name')"
      @change="validate(selectVal)"
    >
      <template v-slot:no-options="{ searching }">
        <template v-if="searching">
          {{ $t("interface.searchEmpty") }}
        </template>
        <template v-else> {{ $t("interface.listEmpty") }} </template>
      </template>
      <template #selected-option-container="{ option }">
        <span class="placeholder-immitation">{{
          $t("fields_labels.name")
        }}</span>
        <span class="placeholder-immitation placeholder-immitation_overflow"
          ><span>{{ option.label }}</span></span
        >
      </template>
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes">
          <svg
            width="13"
            height="8"
            viewBox="0 0 13 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.5 1.5L6.5 6.5L1.5 1.5"
              stroke="#B2B4B4"
              stroke-linecap="square"
            />
          </svg>
        </span>
      </template>
    </v-select>
    <v-select
      v-if="getThemes"
      :searchable="true"
      v-model="trainingTheme"
      class="selectaria__select selectaria__select_long"
      :options="themes"
      label="label"
      :reduce="(themes) => themes.value"
      :closeOnSelect="true"
      :placeholder="$t('fields_labels.training_theme')"
      @change="validate(selectVal)"
    >
      <template v-slot:no-options="{ searching }">
        <template v-if="searching">
          {{ $t("interface.searchEmpty") }}
        </template>
        <template v-else> {{ $t("interface.listEmpty") }} </template>
      </template>
      <template #selected-option-container="{ option }">
        <span class="placeholder-immitation">{{
          $t("fields_labels.training_theme")
        }}</span>
        <span class="placeholder-immitation placeholder-immitation_overflow"
          ><span>{{ option.label }}</span></span
        >
      </template>
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes">
          <svg
            width="13"
            height="8"
            viewBox="0 0 13 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.5 1.5L6.5 6.5L1.5 1.5"
              stroke="#B2B4B4"
              stroke-linecap="square"
            />
          </svg>
        </span>
      </template>
    </v-select>

    <!-- <v-input
      v-model="secondName"
      label-style="label-border"
      :label="$t('fields_labels.name')"
      class="filter__second-name"
    >
      <template v-slot:clear>
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="#B2B4B2"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </v-input>
    <v-input
      v-model="trainingTheme"
      label-style="label-border"
      :label="$t('fields_labels.training_theme')"
      class="filter__theme"
    >
      <template v-slot:clear>
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="#B2B4B2"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </v-input> -->

    <v-select
      :searchable="false"
      v-model="year"
      class="selectaria__select"
      :options="itemsYear"
      label="label"
      :reduce="(itemsYear) => itemsYear.value"
      :closeOnSelect="true"
      :placeholder="$t('fields_labels.year')"
      @change="validate(selectVal)"
    >
      <template #selected-option-container="{ option }">
        <span class="placeholder-immitation">{{
          $t("fields_labels.year")
        }}</span>
        <span class="placeholder-immitation placeholder-immitation_overflow"
          ><span>{{ option.label }}</span></span
        >
      </template>
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes">
          <svg
            width="13"
            height="8"
            viewBox="0 0 13 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.5 1.5L6.5 6.5L1.5 1.5"
              stroke="#B2B4B4"
              stroke-linecap="square"
            />
          </svg>
        </span>
      </template>
    </v-select>
    <v-select
      :searchable="false"
      v-model="month"
      class="selectaria__select"
      :options="itemsMonths"
      label="label"
      :reduce="(itemsMonths) => itemsMonths.value"
      :closeOnSelect="true"
      :placeholder="$t('fields_labels.month')"
      @change="validate(selectVal)"
    >
      <template #selected-option-container="{ option }">
        <span class="placeholder-immitation">{{
          $t("fields_labels.month")
        }}</span>
        <span class="placeholder-immitation placeholder-immitation_overflow"
          ><span>{{ option.label }}</span></span
        >
      </template>
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes">
          <svg
            width="13"
            height="8"
            viewBox="0 0 13 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.5 1.5L6.5 6.5L1.5 1.5"
              stroke="#B2B4B4"
              stroke-linecap="square"
            />
          </svg>
        </span>
      </template>
    </v-select>
    <AppBtn
      @click.native="filtering()"
      :btnClass="'btn_secondary'"
      class="w-100 w-md-auto _mt-sm-4"
    >
      <span class="_py-4 _px-6 _px-md-15 _fs-16">
        {{ $t("interface.find") }}
      </span>
    </AppBtn>
  </div>
</template>

<script>
import AppBtn from "@/components/UI/buttons/AppBtn";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "QualificationFilter",
  components: {
    AppBtn,
  },
  props: {
    access: Boolean,
  },
  data: () => ({
    secondName: "",
    trainingTheme: "",
    year: "",
    month: "",
  }),
  computed: {
    ...mapGetters(["getLectors", "getThemes"]),
    currentLocale() {
      return this.Trans.currentLocale;
    },
    itemsMonths() {
      return [{ label: this.$t("interface.emptyWord"), value: null }].concat(
        this.$t("interface.months").map((item, ind) => ({
          label: item,
          value: ind + 1,
        }))
      );
    },
    itemsYear() {
      return [
        { label: this.$t("interface.emptyWord"), value: null },
        { label: "2022", value: 2022 },
        { label: "2021", value: 2021 },
        { label: "2020", value: 2020 },
      ];
    },
    lectors() {
      return this.getLectors.map(function (el) {
        return {
          label: `${el.translates?.[0]?.first_name || el.first_name} ${
            el.translates?.[0]?.last_name || el.last_name
          }`,
          value: el.id,
          id: el.id,
        };
      });
    },
    themes() {
      return this.getThemes.map(function (el, i) {
        return {
          label: el.translates[0].title,
          value: el.translates[0].title,
          id: i,
        };
      });
    },
    filter() {
      return {
        year: this.year,
        month: this.month,
        lector: this.secondName,
        theme: this.trainingTheme,
      };
    },
  },
  methods: {
    ...mapActions([
      "fetchLectors",
      "fetchTrainingsList",
      "fetchTrainingsThemes",
    ]),
    async filtering() {
      await this.fetchTrainingsList({
        lang: this.currentLocale,
        access: this.access,
        filter: this.filter,
      });
    },
  },
  async mounted() {
    await this.fetchLectors({ lang: this.currentLocale, access: this.access });
    await this.fetchTrainingsThemes({
      lang: this.currentLocale,
      access: this.access,
      filter: {
        lector: this.secondName,
      },
    });
  },
  watch: {
    async secondName() {
      await this.fetchTrainingsThemes({
        lang: this.currentLocale,
        access: this.access,
        filter: {
          lector: this.secondName,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  margin-top: 24px;
  margin-bottom: 64px;
  display: grid;
  grid-template-columns: 280px 280px 176px 176px 176px;
  column-gap: 32px;

  @media screen and (max-width: 1220px) {
    // width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    margin: 24px -16px 24px;

    & .vmq-input-wrapper {
      width: calc(50% - 32px);
      margin: 0 16px 24px;
    }

    & .selectaria__select.selectaria__select_long {
      width: calc(50% - 32px);
      margin: 0 16px 24px;
    }

    & .v-select {
      width: 33.3333333%;
      margin: 0 16px;
    }
  }

  @media screen and (max-width: 767px) {
    margin: 24px -8px 24px;
    & .vmq-input-wrapper {
      width: calc(100% - 8px);
      margin: 0 4px 16px;
    }

    & .selectaria__select.selectaria__select_long {
      width: calc(100% - 8px);
      margin: 0 4px 16px;
    }

    & .v-select {
      width: calc(50% - 8px);
      margin: 0 4px;
    }
  }
}
</style>
<style lang="scss">
.selectaria {
  width: 100%;
  &__label {
    margin-bottom: 16px;
    font-family: "Noto-Sans", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #1f1f1f;
  }

  &__select {
    padding: 0 16px;
    width: 100%;
    height: 56px;
    max-width: 384px;
    border: 1px solid #d4d4d4;
    border-radius: 5px;
    font-family: "Noto-Sans", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #707372;
    background-color: #fff;
    display: block;
    transition: 0.3s;
    .vs__dropdown-toggle {
      height: 100%;
      border: none;
      padding: 0;
      .vs__search::placeholder {
        font-family: "Noto-Sans", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 21px;
        color: #707372;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .vs__search:placeholder-shown {
        text-overflow: ellipsis;
      }
      .vs__search,
      .vs__search:focus {
        margin: 0;
        padding: 0;
        overflow: hidden;
      }
      .vs__clear {
        display: none;
      }

      .vs__selected {
        margin: 0;
        position: static;
        opacity: 1;

        &-options {
          width: 90%;
        }
      }
    }

    .vs__dropdown-option {
      white-space: inherit;
    }
  }
  &__error {
    margin-top: 8px;
    font-family: "Noto-Sans", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #cb4050;
  }
  &_error {
    & .selectaria__select {
      border-color: #cb4050;
      background-color: #faebed;
    }
  }
}

.placeholder-immitation {
  position: static;
  font-family: "Noto-Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #707372;
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:first-child {
    padding: 0 5px;
    position: absolute;
    background-color: #fff;
    top: -10px;
    left: -2px;
    display: flex;
    align-items: center;
    line-height: 1.4;
    font-size: 1em;
    font-family: "Noto-Sans", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 21px;
    color: #707372;
    text-overflow: ellipsis;
    overflow: hidden;
    transition: 0.3s;
  }
}

.placeholder-immitation_overflow {
  height: 54px;
  width: 100%;
  min-width: 0px;

  & span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.vs__dropdown-option--selected {
  color: #77bb2f !important;
}

.vs__dropdown-option--deselect {
  background: none;
  color: inherit;
}

.vs__dropdown-option--highlight {
  background: none;
  color: inherit;
}

.vs__dropdown-option:hover {
  background: #77bb2f;
  color: #fff !important;
}
</style>
<style>
.vs__dropdown-option:hover .checkbox__label {
  color: #fff !important;
}
</style>
